import { gql } from '@apollo/client';

export const ONCALL_MANAGEMENT_SCHEDULE_AGENT_FIELDS = gql`
  fragment OnCallAgentFields on PlatformUser {
    id
    firstName
    lastName
  }
`;

export const ONCALL_MANAGEMENT_SCHEDULE_PARTNER_FIELDS = gql`
  fragment OnCallPartnerFields on Partner {
    id
    partnerId
  }
`;
export const ONCALL_MANAGEMENT_SCHEDULE_QUERY_FIELDS = gql`
  fragment OncallManagementScheduleQueryFields on OncallManagementSchedule {
    id
    oncallManagementScheduleId
    createdAt
    startTime
    endTime
    recurrence
    recurrenceUntil
    updatedAt
    primaryAgent {
      ...OnCallAgentFields
    }
    secondaryAgent {
      ...OnCallAgentFields
    }
    partner {
      ...OnCallPartnerFields
    }
    conditions
  }
  ${ONCALL_MANAGEMENT_SCHEDULE_AGENT_FIELDS}
  ${ONCALL_MANAGEMENT_SCHEDULE_PARTNER_FIELDS}
`;
export const ONCALL_MANAGEMENT_SCHEDULE_FIELDS = gql`
  fragment OncallManagementScheduleFields on OncallManagementSchedule {
    id
    oncallManagementScheduleId
    createdAt
    startTime
    endTime
    recurrence
    recurrenceUntil
    updatedAt
    primaryAgentId
    secondaryAgentId
    partnerId
    conditions
  }
`;
